import { requireApp } from 'store/assertions';

type SizesResponse = {
    grids?: Array<{
        geodatas?: Array<{
            id?: string;
            simulationSets?: Array<{
                id?: string;
                simulations?: Array<{
                    id?: number;
                    RaysSize?: number;
                    MultiLinesSize?: number;
                }>;
            }>;
        }>;
    }>;
};

const raysSizeBySubSimulation = new Map<string, number>();

const readNumericSize = (value: unknown): number | null => (typeof value === 'number' && Number.isFinite(value) ? value : null);

const getSubSimulationCacheKey = (subSimulationId: number): string => String(subSimulationId);

const hydrateRaysSizesForSimulationSet = async (simulationSetId: string): Promise<void> => {
    const response = await requireApp().apiClient.get<SizesResponse>(
        `v2/sizes?${new URLSearchParams({ simulation_ids: simulationSetId, refresh: '0' }).toString()}`
    );

    for (const grid of response.data.grids ?? []) {
        for (const geodata of grid.geodatas ?? []) {
            const simulationSet = geodata.simulationSets?.find((entry) => entry.id === simulationSetId);
            if (!simulationSet) continue;

            for (const simulation of simulationSet.simulations ?? []) {
                if (simulation.id == null) continue;

                const raysSize = readNumericSize(simulation.RaysSize);
                if (raysSize !== null) {
                    raysSizeBySubSimulation.set(getSubSimulationCacheKey(simulation.id), raysSize);
                    continue;
                }

                const multiLinesSize = readNumericSize(simulation.MultiLinesSize);
                if (multiLinesSize !== null) {
                    raysSizeBySubSimulation.set(getSubSimulationCacheKey(simulation.id), multiLinesSize);
                }
            }
        }
    }
};

export const getRaysSizeForLayer = async (simulationSetId: string, subSimulationId: number): Promise<number | null> => {
    const cacheKey = getSubSimulationCacheKey(subSimulationId);
    const cached = raysSizeBySubSimulation.get(cacheKey);
    if (cached !== undefined) {
        return cached;
    }

    await hydrateRaysSizesForSimulationSet(simulationSetId);
    return raysSizeBySubSimulation.get(cacheKey) ?? null;
};
